import AccountSettingsPanel from '../components/auth/account-settings/AccountSettingsPanel';

function AccountSettings() {
  return <AccountSettingsPanel />;
}

export default AccountSettings;
